/**
 * Wrapper az electronhoz csinált, saját openUrl függvényünkhöz, amivel
 * külső hivatkozásokat lehet hívni.
 * Igy könnyeb tesztnél kimockolni, nem kell ott hegeszteni.
 * @param link - A külső link, amit hívni fogunk.
 */
export default function openExternalUrl (link: string): void {
  /** Lásd a preload.js fájlt, ott van definiálva az openUrl. */
  const { openUrl } = window as unknown as { openUrl: (link: string) => void }

  openUrl(link)
}
